/** Public ranking snapshot, grouped so tied records share a single track marker. */
export function flightRecords(items) {
  const groups = new Map();
  for (const item of Array.isArray(items) ? items : []) {
    if (!Number.isSafeInteger(item.place) || item.place < 1 || item.place > 10
        || !Number.isSafeInteger(item.score) || item.score < 5) continue;
    const entry = { place: item.place, name: String(item.name || "Игрок").slice(0, 40) };
    const group = groups.get(item.score) || [];
    group.push(entry); groups.set(item.score, group);
  }
  return [...groups].sort(([a], [b]) => a - b).map(([score, players]) => {
    players.sort((a, b) => a.place - b.place);
    const first = players[0];
    return { score, place: first.place, name: first.name, count: players.length,
      label: `#${first.place} ${first.name}${players.length > 1 ? ` +${players.length - 1}` : ""}` };
  });
}

/** The line reaches the witch at x=90 exactly when the target score is awarded. */
export function recordMarkerX(score, distance) {
  return (400000 + (score - 1) * 230000 + 44001 - distance) / 1000;
}

export function nextFlightRecord(records, score) {
  return records.find(record => record.score >= score) || null;
}

export function drawFlightRecords(ctx, records, distance, width, height) {
  for (const record of records) {
    const x = recordMarkerX(record.score, distance);
    if (x < -20 || x > width + 20) continue;
    ctx.save();
    ctx.strokeStyle = "#f4ca79aa"; ctx.lineWidth = 1;
    ctx.setLineDash([4, 7]); ctx.beginPath(); ctx.moveTo(x, 167); ctx.lineTo(x, height - 45); ctx.stroke();
    ctx.setLineDash([]);
    const labelWidth = 142, labelX = Math.max(8, Math.min(width - labelWidth - 8, x - labelWidth / 2));
    ctx.fillStyle = "#171326ed"; ctx.fillRect(labelX, 145, labelWidth, 32);
    ctx.fillStyle = "#f4ca79"; ctx.font = "bold 10px sans-serif";
    const label = record.label.length > 22 ? `${record.label.slice(0, 21)}…` : record.label;
    ctx.fillText(label, labelX + 7, 158, labelWidth - 14);
    ctx.fillStyle = "#f6f5ff"; ctx.font = "10px sans-serif";
    ctx.fillText(`${record.score} очков`, labelX + 7, 171, labelWidth - 14);
    ctx.restore();
  }
}
